import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var ControlButton = styled.div.withConfig({
  displayName: "Controls__ControlButton",
  componentId: "sc-wc968y-0"
})(["display:inline-block;position:relative;padding:3px;border:1px solid ", ";border-radius:50%;box-shadow:0 2px 0 rgb(0 0 0 / 0.015);cursor:pointer;background-color:", ";font-size:16px;font-weight:400;line-height:1;white-space:nowrap;text-align:center;svg{vertical-align:middle;stroke:", ";}"], function (_ref) {
  var controlsColor = _ref.controlsColor;
  return controlsColor ? controlsColor : '#eee';
}, function (_ref2) {
  var controlsColor = _ref2.controlsColor;
  return controlsColor ? 'transparent' : '#fff';
}, function (_ref3) {
  var controlsColor = _ref3.controlsColor,
    theme = _ref3.theme;
  return controlsColor ? controlsColor : theme.colors.terciaryDD;
});
export var ControlsContainer = styled.div.withConfig({
  displayName: "Controls__ControlsContainer",
  componentId: "sc-wc968y-1"
})(["display:", ";position:absolute;z-index:20;top:50%;top:calc(50% - 20px);width:100%;", ";"], function (_ref4) {
  var alwaysShowControls = _ref4.alwaysShowControls;
  return alwaysShowControls ? 'block' : 'none';
}, minMediaQueries.tablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: block;\n  "]))));
export var ControlLeftButtonContainer = styled.div.withConfig({
  displayName: "Controls__ControlLeftButtonContainer",
  componentId: "sc-wc968y-2"
})(["position:absolute;top:0;", ""], function (_ref5) {
  var visible = _ref5.visible;
  return !visible && "opacity: 0;";
});
export var ControlRightButtonContainer = styled.div.withConfig({
  displayName: "Controls__ControlRightButtonContainer",
  componentId: "sc-wc968y-3"
})(["position:absolute;right:0;", ""], function (_ref6) {
  var visible = _ref6.visible;
  return !visible && "opacity: 0;";
});